import { Weblog } from '@ks/weblogger';

type LoggerEventType = 'CLICK' | 'SHOW' | 'CUSTOM';
type LoggerPage = 'MAIN' | string;

interface LoggerEventParams {
  action: string;
  params?: Record<string, unknown>;
  contentPackage?: string;
  urlPage?: {
    page: string;
  };
}

interface InitWebloggerConfig {
  env?: 'production' | 'development';
  productName: string;
}

const DEFAULT_PRODUCT_NAME = 'KIM_DESKTOP';
const DEFAULT_EVENT_TYPE: LoggerEventType = 'CLICK';
const DEFAULT_ENV: InitWebloggerConfig['env'] =
  process.env.NODE_ENV === 'production' ? 'production' : 'development';

let weblogger: Weblog | null = null;

function buildDefaultContentPackage() {
  return JSON.stringify({
    traceId: `${Date.now()}-${Math.random()}`,
  });
}

export function initWeblogger(
  config: InitWebloggerConfig = { productName: DEFAULT_PRODUCT_NAME },
) {
  if (weblogger) {
    return weblogger;
  }

  const isProduction = (config.env || DEFAULT_ENV) === 'production';
  weblogger = new Weblog(
    {
      env: 'production',
      autoPV: false,
      autoPVFilter: () => true,
      crash: true,
      fps: false,
      timing: false,
      retries: 3,
      maxBatchLength: 100,
      wait: 1000,
      lazy: false,
      useBeacon: false,
      logger: !isProduction,
    },
    {
      product_name: config.productName || DEFAULT_PRODUCT_NAME,
    },
  );

  return weblogger;
}

export function reportEvent(
  eventParams: LoggerEventParams,
  eventType: LoggerEventType = DEFAULT_EVENT_TYPE,
) {
  try {
    if (!weblogger) {
      initWeblogger();
    }

    weblogger?.sendImmediately(eventType, {
      action: eventParams.action,
      params: {
        timestamp: Date.now(),
        url: window.location.href,
        ...eventParams.params,
      },
      contentPackage: eventParams.contentPackage || buildDefaultContentPackage(),
      urlPage: eventParams.urlPage,
    });
  } catch (error) {
    console.error('[weblogger] report event failed:', error);
  }
}

export function collectLog(
  page: LoggerPage,
  options: Omit<LoggerEventParams, 'urlPage'>,
  eventType: LoggerEventType = DEFAULT_EVENT_TYPE,
) {
  reportEvent(
    {
      ...options,
      urlPage: { page },
    },
    eventType,
  );
}
